export const environment = {
	production: false,
	appVersion: 'v0.0.1',
	isMockEnabled: false,
	api: 'https://loyalty-staging.spotside.com/api',
	keycloak: {
		url: 'https://accounts.spotside.com/',
		realm: 'spotside',
		clientId: 'dev-andy',
		adminRole: 'view-profile',
	},
	project: 'loyalty-card',
	keycloak_account: 'https://accounts.spotside.com/realms/spotside/account',
};
